import React from 'react'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import LinkButton from 'srcReact/components/common2/LinkButton'

export default function GeneralGroupCreated() {
  const { t } = useTranslation()
  return (
    <PageContainer pageClassName={styles.createdPageContainer} pageTitle='general-group-created' withFooter={false}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t('workplace.group_created.title')}</h1>
        <p className={styles.description}>{t('workplace.group_created.description')}</p>
        <LinkButton
          href='/0/myhome'
          className={styles.button}
          size='large'
          text={t('workplace.group_created.button')}
        />
      </div>
    </PageContainer>
  )
}
